import React from 'react';

export function toAddress(flexAddress) {
    const {
        line1,
        line2,
        city,
        stateOrRegion,
        postalCode
    } = flexAddress;
    if (!line1 || !city) {
        return <span>No address provided</span>;
    }

    return <span>
        {line1} {line2}
        <br/>
        {city}, {stateOrRegion} {postalCode}
    </span>;
}